import React from 'react';
import { rs, BUCKET_LABEL } from './vpUtils';

const CARDS = [
  ['vendors', 'Total Vendors', 'n'], ['invoices', 'Total Invoices', 'n'], ['invoice_value', 'Total Invoice Value (Incl GST)', 'rs'],
  ['paid', 'Total Payment Made', 'rs', 'text-emerald-700'], ['outstanding', 'Total Outstanding', 'rs', 'text-red-600'],
  ['fully_paid', 'Fully Paid Invoices', 'n', 'text-emerald-700', { payment_status: 'fully_paid' }],
  ['partially_paid', 'Partially Paid Invoices', 'n', 'text-amber-700', { payment_status: 'partially_paid' }],
  ['pending', 'Pending / Unpaid Invoices', 'n', 'text-red-600', { payment_status: 'pending' }],
  ['overdue', 'Overdue Invoices', 'n', 'text-red-700', { bucket: 'overdue' }], ['completion_pct', 'Payment Completion', 'pct'],
];

export const VPCards = ({ cards, onDrill }) => (
  <div className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-5" data-testid="vp-cards">
    {CARDS.map(([k, label, kind, tone = 'text-slate-900', drill]) => (
      <button key={k} type="button" disabled={!drill} onClick={() => drill && onDrill(drill)} data-testid={`vp-card-${k}`}
        className="rounded-xl border border-slate-200 bg-white px-4 py-3 text-left shadow-sm transition-[box-shadow,transform] enabled:hover:-translate-y-0.5 enabled:hover:shadow-md">
        <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">{label}</p>
        <p className={`mt-1 text-xl font-bold ${tone}`}>
          {kind === 'rs' ? rs(cards?.[k]) : kind === 'pct' ? `${cards?.[k] ?? 0}%` : (cards?.[k] ?? 0)}
        </p>
      </button>
    ))}
  </div>
);

export const VPAgeing = ({ ageing, onDrill }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid="vp-ageing">
    <h3 className="mb-3 text-sm font-semibold text-slate-800">Invoice Ageing (outstanding only, from supplier invoice date)</h3>
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
      {(ageing || []).map((a) => (
        <button key={a.bucket} type="button" onClick={() => onDrill({ bucket: a.bucket })} data-testid={`vp-ageing-${a.bucket}`}
          className={`rounded-lg border px-4 py-3 text-left transition-colors hover:bg-slate-50 ${a.bucket === '90+' ? 'border-red-200' : 'border-slate-200'}`}>
          <p className="text-xs font-medium text-slate-500">{BUCKET_LABEL[a.bucket]}</p>
          <p className="text-lg font-bold text-slate-900">{rs(a.outstanding)}</p>
          <p className="text-xs text-slate-500">{a.count} invoice{a.count === 1 ? '' : 's'}</p>
        </button>
      ))}
    </div>
  </div>
);
